module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container container-table loginpage"
  }, [_c('div', {
    staticClass: "row vertical-10p logincntrrow"
  }, [_c('div', {
    staticClass: "container logincntr"
  }, [_c('div', {
    staticClass: "text-center col-md-4 col-sm-offset-4 loginFormwrp"
  }, [_c('img', {
    staticClass: "center-block logina-logo",
    attrs: {
      "src": "/static/img/d2dvoyager-logo.png"
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "ui form loginForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('div', {
    staticClass: "error loginModuleToperror"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('username')),
      expression: "errors.has('username')"
    }],
    staticClass: "error "
  }, [_vm._v(_vm._s(_vm.errors.first('username')))])]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    class: _vm.errors.has('username') ? 'error' : ''
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        email: true
      }),
      expression: "{ email: true }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "username",
      "name": "username",
      "placeholder": "Email",
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "blur": _vm.validemail,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "validate form-control",
    attrs: {
      "id": "password",
      "type": "password",
      "placeholder": "password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "loginsubmitwrp"
  }, [_vm._v("\n            Forgot Password?  \n            "), _c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": _vm.forgetpassword
    }
  }, [_vm._v("Reset here")]), _vm._v(" "), _c('button', {
    class: 'loginsubmit btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Login")])])]), _vm._v(" "), (_vm.response) ? _c('div', {
    staticClass: "text-red"
  }, [_c('p', [_vm._v(_vm._s(_vm.response))])]) : _vm._e()])])]), _vm._v(" "), _c('simplert', {
    ref: "simplert",
    attrs: {
      "useRadius": true,
      "useIcon": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-lock"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f565fa2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 1016
// module chunks = 1